import { BrowserRouter,Routes,Route } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import Layout from './Components/Layout/Layout';
import About from './Pages/About';
import ContactUs from './Pages/ContactUs';
import Services from './Pages/Services';
import PrivacyPolicy from './Components/Policies and Conditions/PrivacyPolicy';
import TermsCondtions from './Components/Policies and Conditions/TermsCondtions';
import LoadingPage from './Components/LoadingPage/LoadingPage';

function App() {
  return (
    <div>
    <LoadingPage/>
        <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/about" element={<Layout><About /></Layout>} />
              <Route path='/services' element={<Layout><Services/></Layout>} />
              <Route path='/contactus' element={<Layout><ContactUs/></Layout>} />
              <Route path='/privacy-policy' element={<Layout><PrivacyPolicy/></Layout>} />
              <Route path='/terms-&-conditions' element={<Layout><TermsCondtions/></Layout>} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
